import { combineReducers } from "redux";
	
// import users from "./users";
import login from "./loginReducer";
import sidebar from "./sidebarReducer"

export default combineReducers({ login, sidebar });
